import { useState } from 'react';

const EditModal = ({ title, fields, initialValues = {}, onSave, onCancel }) => {
  const [form, setForm] = useState({ ...initialValues });
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'file') {
      // Los archivos se manejan externamente (via onChange del field)
      return;
    }
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await onSave(form);
    } catch (err) {
      alert(err.response?.data?.error || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="sp-modal-backdrop" onClick={onCancel}>
      <div className="sp-modal" style={{ maxWidth: 600, width: '100%', maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <h3 className="sp-modal__title">{title}</h3>
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gap: '0.85rem', margin: '1.25rem 0' }}>
            {fields.map(field => (
              <div className="sp-field" key={field.name}>
                <label className="sp-field__label">{field.label}</label>
                {field.type === 'checkbox' ? (
                  <label className="sp-toggle">
                    <span className="sp-toggle__title">{field.label}</span>
                    <div className="sp-switch">
                      <input
                        type="checkbox"
                        name={field.name}
                        checked={!!form[field.name]}
                        onChange={handleChange}
                      />
                      <span className="sp-switch__slider"></span>
                    </div>
                  </label>
                ) : field.type === 'textarea' ? (
                  <textarea
                    className="sp-field__input"
                    name={field.name}
                    value={form[field.name] ?? ''}
                    onChange={handleChange}
                    rows={field.rows || 3}
                  />
                ) : field.type === 'file' ? (
                  <input
                    type="file"
                    accept={field.accept}
                    onChange={(e) => {
                      if (field.onChange) field.onChange(e);
                      // También se puede almacenar internamente
                      setForm(prev => ({ ...prev, [field.name]: e.target.files[0] }));
                    }}
                  />
                ) : (
                  <input
                    className="sp-field__input"
                    type={field.type || 'text'}
                    name={field.name}
                    value={form[field.name] ?? ''}
                    onChange={handleChange}
                    step={field.step}
                    min={field.min}
                    max={field.max}
                  />
                )}
              </div>
            ))}
          </div>
          <div className="sp-modal__actions">
            <button type="button" className="sp-btn sp-btn--light" onClick={onCancel} disabled={saving}>
              Cancelar
            </button>
            <button type="submit" className="sp-btn sp-btn--primary" disabled={saving}>
              {saving ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditModal;